module.exports = __webpack_public_path__ + "static/biotwo-a160c3a93580a4fb30f6f29b39a42ff4.jpg";